import { render, staticRenderFns } from "./Imagem.vue?vue&type=template&id=7070f8b8"
import script from "./Imagem.vue?vue&type=script&lang=js"
export * from "./Imagem.vue?vue&type=script&lang=js"
import style0 from "./Imagem.vue?vue&type=style&index=0&id=7070f8b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports